module.exports = __webpack_public_path__ + "img/001.f15ecdd9.png";